import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { Context } from './types'

/** Cluster functional usage API, for fetching and updating functional usage */
@ngCore.Injectable()
export class Api {
  /** Gets functional usage for a space cluster */
  public get(
    context: Context,
  ): rxjs.Observable<ents.extra.space.Functionalization[]> {
    return gql.queries.clusterFunctionalUsage.executor(context)
  }

  /** Updates functional usage for a space cluster */
  public update({
    context,
    functionalizations,
  }: {
    context: Context
    functionalizations: ents.extra.space.Functionalization[]
  }): rxjs.Observable<ents.extra.space.Functionalization[]> {
    return gql.mutations.updateClusterFunctionalUsage.executor({
      ...context,
      functionalizations: functionalizations.map(f => ({
        functionId: f.functionId,
        percent: f.percent,
      })),
    })
  }
}
